import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { UserPermissions } from "core/enum";

import {
  Page,
  CheckBox,
  IconButton,
  If,
  Loadable,
  DescriptionField,
  StyledButton
} from "components/support";

import Icon from "material-ui-next/Icon";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import MuiIconButton from "material-ui-next/IconButton";
import List, {
  ListItem,
  ListItemText,
  ListItemSecondaryAction
} from "material-ui-next/List";

import { colors } from "assets";

import style from "./style";

class UserInfoView extends Component {
  constructor(props) {
    super(props);
    this.router = props.transition.router;
    this.presenter = props.presenter;
  }

  handleDelete = (companyUuid, uuid) => {
    this.presenter.onDelete(companyUuid, uuid);
  };

  showPermissions = () => {
    const { form } = this.props.viewModel;

    if (form.permissions !== undefined && form.permissions !== null) {
      return form.permissions
        .filter(permission => !!UserPermissions[permission])
        .map((permission, k) => (
          <Col key={k} xs={12} lg={4} className="user-info--permission">
            <div className="user-info--icon">
              <Icon style={{ fontSize: "2em", color: "#000" }}>done</Icon>
            </div>
            <div>{UserPermissions[permission]}</div>
          </Col>
        ));
    }
  };

  redirectTo = (whereTo, params = {}) => {
    this.router.stateService.go(whereTo, params, {});
  };

  render() {
    const { className, viewModel, presenter } = this.props;
    const {
      loading,
      title,
      currentUser,
      form,
      allowedCompanies,
      tokens
    } = viewModel;

    return (
      <Page>
        <Col xs={12}>
          <Typography type="display1" className="pb-sm">
            <Row>
              <Col xs={12} sm>
                <IconButton
                  icon="arrow_back"
                  onClick={() => this.props.presenter.onViewUser()}
                />
                {title}
              </Col>
              <Col>
                <IconButton
                  icon="mode_edit"
                  onClick={() => this.props.presenter.onEditUser(form)}
                />
                {currentUser.uuid !== form.uuid && (
                  <IconButton
                    mini
                    icon="delete"
                    onClick={() => this.props.presenter.onRequestDelete(form)}
                  />
                )}
              </Col>
            </Row>
          </Typography>
          <div className={className}>
            <Paper elevation={1}>
              <Loadable loading={loading}>
                <Row>
                  <Col xs={6}>
                    <div className="grid-container mb-sm">
                      <Row>
                        <Col xs={12}>
                          <DescriptionField
                            label="E-mail"
                            value={form.username}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <DescriptionField
                            label="Empresa"
                            value={form.companySlug}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col xs={12} lg={6}>
                    <div className="div-label-class">
                      <span className="label-class">Empresas disponíveis</span>
                      <Paper elevation={2} className="paper-class">
                        <div className="grid-container allowed-companies">
                          <Row>
                            {allowedCompanies.map((company, index) => {
                              return (
                                <Col
                                  xs={6}
                                  key={`col-${index}`}
                                  className="allowed-companies-col"
                                >
                                  <Row middle="xs">
                                    <Col xs={3}>
                                      <CheckBox
                                        checked={form.allowed_companies_uuids.includes(
                                          company.uuid
                                        )}
                                        disabled
                                      />
                                    </Col>
                                    <Col xs={9}>
                                      <If test={company.cnpj}>
                                        <span className="allowed-companies-slug">
                                          {company.slug}
                                        </span>
                                        <span className="allowed-companies-cnpj">
                                          {company.cnpj}
                                        </span>
                                      </If>
                                      <If test={!company.cnpj}>
                                        <span className="allowed-companies-slug">
                                          {company.slug}
                                        </span>
                                      </If>
                                    </Col>
                                  </Row>
                                </Col>
                              );
                            })}
                          </Row>
                        </div>
                      </Paper>
                    </div>
                  </Col>
                  <div className="user-info--permission-div">
                    <Col xs={12} className="user-info--span">
                      <span className="user-info--main">Permissões: </span>
                    </Col>
                    <Row className="user-info--description">
                      {(form.permissions === undefined ||
                        form.permissions === null ||
                        form.permissions.length === 0) && (
                        <Col xs={12} className="user-info--permission">
                          <div className="user-info--icon">
                            <Icon style={{ fontSize: "2em", color: "red" }}>
                              error
                            </Icon>
                          </div>
                          <div style={{ color: colors.rede.normal }}>
                            Não há permissões para este usuário.
                          </div>
                        </Col>
                      )}
                      {this.showPermissions()}
                    </Row>
                  </div>
                </Row>
                <Row>
                  <Col xs={12} className="user-info--span">
                    <span className="user-info--main">Tokens da API: </span>
                  </Col>

                  <Col xs={12} className="user-info--span">
                    <List dense>
                      {tokens.map(token => (
                        <ListItem key={token.uuid}>
                          <ListItemText primary={token.api_key} />
                          <ListItemSecondaryAction>
                            <MuiIconButton
                              onClick={() => presenter.onDeleteToken(token)}
                            >
                              <Icon>delete</Icon>
                            </MuiIconButton>
                          </ListItemSecondaryAction>
                        </ListItem>
                      ))}
                    </List>
                  </Col>

                  <Col xs={12} className="m-sm">
                    <StyledButton
                      label="Gerar novo token"
                      primary
                      className="m-sm"
                      onTouchTap={() => presenter.onGenerateNewToken()}
                    />
                  </Col>
                </Row>
              </Loadable>
            </Paper>
          </div>
        </Col>
      </Page>
    );
  }
}

export default style(UserInfoView);



// WEBPACK FOOTER //
// ./src/components/app/registration/user/info/user-info.view.jsx